export const cilImagePlus = ["24 24","<path d='M20.625 9.829l-3.036-3.036-3.245 3.245-4.688-4.688-6.281 6.281v-8.257h12.375v-1.5h-13.875v20.25h20.25v-13.5h-1.5zM17.589 8.914l3.036 3.036v4.369l-5.221-5.221zM3.375 20.625v-6.872l6.281-6.281 10.969 10.969v2.185z'></path><path d='M21 3v-2.25h-1.5v2.25h-2.25v1.5h2.25v2.25h1.5v-2.25h2.25v-1.5h-2.25z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-image-plus.js
// module id = null
// module chunks = 